import React from 'react';
import Avatar from '../../Units/Avatar';

const ClubRow = ({ data, avatar,  renderActions }) => {
    return (
        <li className="clubRow">
            <div className="avatarContent">
                <Avatar data={avatar} />
            </div>
            <div className="clubRowInfo">
                <div className="clubRowName">{data.username}</div>
                <div className="clubRowId">{`Club ID: ${data._id || data.accountId}`}</div>
            </div>
            {renderActions ? renderActions(data) : false}
        </li>
    );
};

export default ClubRow;
